import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import {
    ACTION_HOSTNAME_CHANGED,
    ACTION_HEALTHMONITORINTERVAL_CHANGED,
    ACTION_IP_CHANGED,
    ACTION_API_URL_CHANGED,
    ACTION_API_MONITOR_URI_CHANGED,
    ACTION_API_KEY_CHANGED,
    ACTION_GROUP_CHANGED,    
    ACTION_API_USERNAME_CHANGED,
    ACTION_API_PASSWORD_CHANGED,
    ACTION_CRITICALITY_CHANGED,
    ACTION_CONNECTION_TYPE_CHANGED,
    ACTION_CONNECTION_CHANGED,
    ACTION_FIELDSET_CLEANED,
    ACTION_SSH_PASSWORLDESS_KEY_CHANGED,
    ACTION_SSH_USERNAME_CHANGED,
    ACTION_SSH_PASSWORD_CHANGED,
    ACTION_STEP_CHANGED,
    ACTION_DEVICE_TYPE_CHANGED,
    ACTION_STATE_CLEANED,
    ACTION_MSB_NAME_CHANGED,
    ACTION_ASSIGN_COLLECTED_CONFIG_TO_MSB_CHANGED,
    ACTION_ENABLE_ALERTING_CHANGED,
    ACTION_ENABLE_SYSLOG_CONFIG_CHANGED,
    ACTION_ENABLE_EMAIL_NOTIFICATION_CHANGED,
    ACTION_ENABLE_SNMP_NOTIFICATION_CHANGED,
    ACTION_SELECTED_TAGS_CHANGED,
    ACTION_SELECTED_EVENTS_CHANGED,
    ACTION_ENABLE_SYSLOG_PROCESSING_CHANGED,
    ACTION_SELECTED_DEVICE_CHANGED,
    ACTION_MSB_CHANGED,
    ACTION_PORT_CHANGED,
    ACTION_WINRM_USERNAME_CHANGED,
    ACTION_WINRM_PASSWORD_CHANGED,
    ACTION_ENABLE_PASSWORD_CHANGED,
    ACTION_ENABLE_PASSWORD_TEXT_CHANGED,
    ACTION_POWERCLI_USERNAME_CHANGED,
    ACTION_POWERCLI_PASSWORD_CHANGED,
    ACTION_ENABLE_SYSTEM_REMEDIATION_CHANGED,
    ACTION_DOMAIN_CHANGED,
    ACTION_DOMAIN_SET_CHANGED,
    ACTION_CENTRAL_CREDENTIAL_CHANGED,
    ACTION_WINRM_HTTPS_CHANGED,
    ACTION_HTTPS_CERTIFICATE_CHANGED,
    ACTION_MS_TENANT_ID_CHANGED,
    ACTION_MS_CLIENT_ID_CHANGED,
    ACTION_MS_SUBJECT_CHANGED
} from "./AddDeviceModalReducer";
import { deepCopy } from "../../utils";
import * as validationService from './validationService';

export function changeMsb(value) {
    store.dispatch(createAction(ACTION_MSB_CHANGED)({ msbId: value }));
}

export function changeHostName(value) {
    store.dispatch(createAction(ACTION_HOSTNAME_CHANGED)({ hostName: value }));
}

export function changeHealthMonitorInterval(value) {
    store.dispatch(createAction(ACTION_HEALTHMONITORINTERVAL_CHANGED)({ healthMonitorInterval: value }));
}

export function changeIp(value) {
    store.dispatch(createAction(ACTION_IP_CHANGED)({ mngtIpAddress: value }));
}

export function changePort(value) {
    store.dispatch(createAction(ACTION_PORT_CHANGED)({ port: value }));
}

export function changeApiUrl(value) {
    store.dispatch(createAction(ACTION_API_URL_CHANGED)({ apiUrl: value }));
}

export function changeApiMonitorUri(value) {
    store.dispatch(createAction(ACTION_API_MONITOR_URI_CHANGED)({ apiMonitorUri: value }));
}

export function changeApiKey(value) {
    store.dispatch(createAction(ACTION_API_KEY_CHANGED)({ apiKey: value }));
}

export function changeApiUsername(value) {
    store.dispatch(createAction(ACTION_API_USERNAME_CHANGED)({ apiUsername: value }));
}

export function changeApiPassword(value) {
    store.dispatch(createAction(ACTION_API_PASSWORD_CHANGED)({ apiPassword: value }));
}

export function changeGroup(value) {
    store.dispatch(createAction(ACTION_GROUP_CHANGED)({ group: value }));
}

export function changeCentralCredential(value) {
    store.dispatch(createAction(ACTION_CENTRAL_CREDENTIAL_CHANGED)({ centralCredential: value }));
}

export function changeCriticality(value) {
    store.dispatch(createAction(ACTION_CRITICALITY_CHANGED)({ criticality: value }));
}

export function changeConnectionType(value) {
    store.dispatch(createAction(ACTION_CONNECTION_TYPE_CHANGED)({ connectionType: value }));
}

export function changeConnectionStatus(value) {
    store.dispatch(createAction(ACTION_CONNECTION_CHANGED)({ status: value }));
}

export function changePasswordlessKey(value) {
    store.dispatch(createAction(ACTION_SSH_PASSWORLDESS_KEY_CHANGED)({ sshPasswordlessKey: value }));
}

export function changeSshUsername(value) {
    store.dispatch(createAction(ACTION_SSH_USERNAME_CHANGED)({ sshUsername: value }));
}

export function changeWinRmName(value) {
    store.dispatch(createAction(ACTION_WINRM_USERNAME_CHANGED)({ winrmUsername: value }))
}

export function changeSshPassword(value) {
    store.dispatch(createAction(ACTION_SSH_PASSWORD_CHANGED)({ sshPassword: value }));
}

export function changeWinRmPassword(value) {
    store.dispatch(createAction(ACTION_WINRM_PASSWORD_CHANGED)({ winrmPassword: value }));
}

export function changeStep(value) {
    store.dispatch(createAction(ACTION_STEP_CHANGED)({ step: value }));
}

export function changeMsbName(value) {
    store.dispatch(createAction(ACTION_MSB_NAME_CHANGED)({ msbName: value }));
}

export function changeAssignCollectedConfigToMsb(value) {
    store.dispatch(createAction(ACTION_ASSIGN_COLLECTED_CONFIG_TO_MSB_CHANGED)({ assignCollectedConfig: value }));
}

export function changeEnableAlerting(value) {
    store.dispatch(createAction(ACTION_ENABLE_ALERTING_CHANGED)({ enableAlerting: value }));
}

export function changeEnableSyslogConfig(value) {
    store.dispatch(createAction(ACTION_ENABLE_SYSLOG_CONFIG_CHANGED)({ enableSyslogConfigNotification: value }));
}

export function changeEnableSnmpNotification(value) {
    store.dispatch(createAction(ACTION_ENABLE_SNMP_NOTIFICATION_CHANGED)({ enableSnmpNotification: value }));
}

export function changeEnableEmailNotification(value) {
    store.dispatch(createAction(ACTION_ENABLE_EMAIL_NOTIFICATION_CHANGED)({ enableEmailNotification: value }));
}

export function changeEnableSyslogProcessing(value) {
    store.dispatch(createAction(ACTION_ENABLE_SYSLOG_PROCESSING_CHANGED)({ enableSyslogProcessing: value }));
}

export function selectDeviceId(value) {
    store.dispatch(createAction(ACTION_SELECTED_DEVICE_CHANGED)({ deviceTypeId: value }));
}

export function selectTag(newTag, tags) {
    tags = deepCopy(tags);
    tags.push({ name: newTag });
    store.dispatch(createAction(ACTION_SELECTED_TAGS_CHANGED)({ selectedTags: tags }))
}

export function unselectTag(index, tags) {
    tags = deepCopy(tags);
    tags.splice(index, 1);
    store.dispatch(createAction(ACTION_SELECTED_TAGS_CHANGED)({ selectedTags: tags }))
}

export function clearFieldset(keys) {
    for (let key of keys) {
        store.dispatch(createAction(ACTION_FIELDSET_CLEANED)({ [key]: null }))
        validationService.removeValidationKey(key);
    }
}

export function selectEvent(event, selectedEvents) {
    const events = deepCopy(selectedEvents);
    events.push(event);
    store.dispatch(createAction(ACTION_SELECTED_EVENTS_CHANGED)({ selectedEvents: events }));
}

export function unselectEvent(event, selectedEvents) {
    const events = deepCopy(selectedEvents);
    const toRemove = events.find(el => el.id === event.id);
    events.splice(events.indexOf(toRemove), 1);
    store.dispatch(createAction(ACTION_SELECTED_EVENTS_CHANGED)({ selectedEvents: events }));
}

export function selectAllEvents(events) {
    store.dispatch(createAction(ACTION_SELECTED_EVENTS_CHANGED)({ selectedEvents: events }));
}

export function unselectAllEvents() {
    store.dispatch(createAction(ACTION_SELECTED_EVENTS_CHANGED)({ selectedEvents: [] }));
}

export function showModal() {
    store.dispatch(createAction(ACTION_DEVICE_TYPE_CHANGED)({ showModal: true }));
}

export function hideModal() {
    store.dispatch(createAction(ACTION_DEVICE_TYPE_CHANGED)({ showModal: false }));
}

export function cleanState() {
    store.dispatch(createAction(ACTION_STATE_CLEANED)());

}

//Added Feb 22,2022
export function changeEnablePassword(value) {
    store.dispatch(createAction(ACTION_ENABLE_PASSWORD_CHANGED)({ hasEnabledPassword: value }));
}
export function changeEnablePasswordText(value) {
    store.dispatch(createAction(ACTION_ENABLE_PASSWORD_TEXT_CHANGED)({ enablePassword: value }));
}

//Added by Octopus DevTeam Sep 1,2022
export function changePowerCLIUsername(value) {
    store.dispatch(createAction(ACTION_POWERCLI_USERNAME_CHANGED)({ powerCliUsername: value }));
}

export function changePowerCLIPassword(value) {
    store.dispatch(createAction(ACTION_POWERCLI_PASSWORD_CHANGED)({ powerCliPassword: value }));
}

export function changeMSTenantId(value) {
    store.dispatch(createAction(ACTION_MS_TENANT_ID_CHANGED)({ msTenantId: value }));
}

export function changeMSSubject(value) {
    store.dispatch(createAction(ACTION_MS_SUBJECT_CHANGED)({ msSubject: value }));
}

export function changeMSClientId(value) {
    store.dispatch(createAction(ACTION_MS_CLIENT_ID_CHANGED)({ msClientId: value }));
}

export function changeEnableSystemRemediation(value) {
    store.dispatch(createAction(ACTION_ENABLE_SYSTEM_REMEDIATION_CHANGED)({ enableRemediation: value }));
}

export function changeDomain(value) {
    store.dispatch(createAction(ACTION_DOMAIN_CHANGED)({ domain: value }));
}

export function changeDomainSet(value) {
    store.dispatch(createAction(ACTION_DOMAIN_SET_CHANGED)({ domainSet: value }));
}

export function changeWinrmHttps(value) {
    store.dispatch(createAction(ACTION_WINRM_HTTPS_CHANGED)({ winrmhttps: value }));
}

export function changeHttpsCertificatePath(value) {
    store.dispatch(createAction(ACTION_HTTPS_CERTIFICATE_CHANGED)({ httpsCertFilePath: value }));
}

